module.exports = __webpack_public_path__ + "media/images/front/treatment_support/icon_feeling01-ff215287309b06686c23ff71eaedbdbe.svg";